"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchTransferRatesIncludingHistorical = void 0;
const getBestTransferRate_1 = require("./getBestTransferRate");
const searchTransferRatesIncludingHistorical = async (supabase, rates, transfer_line, from_area, to_area, via_area, type, date, passengers, margin_discount_percentage = 0, historic_pricing_adjustment = 5) => {
    const best_rate = await (0, getBestTransferRate_1.getBestTransferRate)(supabase, rates, from_area, to_area, via_area, type, date, passengers, margin_discount_percentage, historic_pricing_adjustment);
    // only add the line if there is a rate
    if (best_rate) {
        transfer_line.supplier = best_rate.supplier;
        transfer_line.vehicle = best_rate.vehicle;
    }
    else {
        transfer_line.vehicle = {
            ...transfer_line?.vehicle,
            rate: {
                ...transfer_line.vehicle.rate,
                type: "CUSTOM",
            },
        };
    }
    if (margin_discount_percentage) {
        transfer_line.adjustments = {
            ...transfer_line.adjustments,
            margin_discount_percentage: margin_discount_percentage,
        };
    }
    return transfer_line;
};
exports.searchTransferRatesIncludingHistorical = searchTransferRatesIncludingHistorical;
